import { Component, OnInit, NgModule, Input, ViewChild, Type, ComponentFactoryResolver } from '@angular/core';
import { HeaderBaseComponent, HeaderComponent, HeaderPartenaireComponent, SideNavigationMenuModule } from '../../shared/components';
import { ScreenService } from '../../shared/services';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxScrollViewModule, DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { CommonModule } from '@angular/common';

import { Router, NavigationEnd } from '@angular/router';
import { HeaderDirective } from '../../shared/components/header/header.directive';
import { TypeUtilisateur } from '@lexi-clients/lexi';
import { AuthService, STORE_KEY_RETURN_URL } from '../../settings/auth.service';
import { HeaderModule } from '../../shared/components/header/header.module';
import { LexiStorage } from '../../settings/lexi-storage';

@Component({
  selector: 'app-side-nav-outer-toolbar',
  templateUrl: './side-nav-outer-toolbar.component.html',
  styleUrls: ['./side-nav-outer-toolbar.component.scss']
})
export class SideNavOuterToolbarComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true }) scrollView: DxScrollViewComponent;
  @ViewChild(HeaderDirective, { static: true }) headerHost: HeaderDirective;
  selectedRoute = '';

  menuOpened: boolean;
  temporaryMenuOpened = false;

  @Input()
  title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
  fullScreen = false;

  constructor(private screen: ScreenService, private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private authService: AuthService,
    private storage: LexiStorage) { }

  ngOnInit() {
    this.menuOpened = this.screen.sizes['screen-large'];

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        const urlParams = new URLSearchParams(val.url);
        const param = urlParams.get('FullScreen');
        if (param) {
          this.fullScreen = true;
        }
        else {
          this.fullScreen = false;
        }
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();

    this.loadHeader();
  }

  loadHeader() {
    // chargement dynamique de component : https://angular.io/guide/dynamic-component-loader
    const components: { [id: string]: Type<HeaderBaseComponent>; } = { };
    components[TypeUtilisateur.collaborateur.toLowerCase()] = HeaderComponent;
    components[TypeUtilisateur.partenaire.toLowerCase()] = HeaderPartenaireComponent;

    let type: Type<HeaderBaseComponent> = components[this.authService.user?.typeUtilisateur];

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(type);

    const viewContainerRef = this.headerHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    componentRef.instance.menuToggleEnabled = true;
    componentRef.instance.title = this.title;
    componentRef.instance.menuToggle.subscribe(s => this.menuOpened = !this.menuOpened);
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event) {
    const path = event.itemData.path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      this.router.navigate([path]);
      this.scrollView.instance.scrollTo(0);

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}

@NgModule({
  imports: [ SideNavigationMenuModule, DxDrawerModule, HeaderModule, DxScrollViewModule, CommonModule ],
  exports: [ SideNavOuterToolbarComponent ],
  declarations: [ SideNavOuterToolbarComponent ]
})
export class SideNavOuterToolbarModule { }
